var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 12.1004C23.4 11.4004 22.9 10.9004 22.2 10.7004C21 10.4004 15.9 10.4004 15.9 10.4004C15.9 10.4004 10.9 10.4004 9.60001 10.7004C8.90001 10.9004 8.4 11.4004 8.2 12.1004C8 13.4004 8 16.0004 8 16.0004C8 16.0004 8 18.6004 8.3 19.9004C8.5 20.6004 9 21.1004 9.7 21.3004C10.9 21.6004 16 21.6004 16 21.6004C16 21.6004 21 21.6004 22.3 21.3004C23 21.1004 23.5 20.6004 23.7 19.9004C24 18.6004 24 16.0004 24 16.0004C24 16.0004 24 13.4004 23.6 12.1004ZM14.4 18.4004V13.6004L18.6 16.0004L14.4 18.4004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeRound);
export default __webpack_public_path__ + "static/media/youtubeRound.c23f96e60c87664fff2474d2d2fb2eb8.svg";
export { ForwardRef as ReactComponent };